/** @format */

import React from "react";

const HeadTitle = ({ title, margin, small }) => {
  return (
    <div className={margin ? "mb__small" : ""}>
      <h2
        className={
          small
            ? "ternary__heading ternary__heading--small "
            : "ternary__heading  "
        }>
        {title}
      </h2>
    </div>
  );
};

export default HeadTitle;
